module.exports = __webpack_public_path__ + "static/img/service-row1.473f6b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/service-row1.png
// module id = D7EW
// module chunks = 1